import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { PumpBasalRateState as BasalRateState } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { usePolyglot } from "src/contexts"
import { DataRecency } from "src/types"

const localizationPrefix = "components.pump_status.basal_rate_state."

export interface Props extends ComponentPropsWithoutRef<"div"> {
  pumpStatus: PumpStatus;
  pumpStatusRecency: DataRecency;
}

export const PumpBasalRateState = forwardRef<HTMLDivElement, Props>(
  function PumpBasalRateState(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      pumpStatus,
      pumpStatusRecency,
      ...divProps
    } = props

    const { basal_rate_state: basalRateState } = pumpStatus

    const polyglot = usePolyglot()

    const basalRateStateString: string = useMemo(
      () => {
        if (pumpStatusRecency === DataRecency.Stale) {
          return polyglot.t(`${localizationPrefix}basal_rate`)
        }

        switch (basalRateState) {
          case BasalRateState.Temp:
          case BasalRateState.TempZero:
            return polyglot.t(`${localizationPrefix}temp`)
          case BasalRateState.SuspendedBasalIQ:
          case BasalRateState.AllDeliveriesStopped:
            return polyglot.t(`${localizationPrefix}all_deliveries_stopped`)
          default:
            return polyglot.t(`${localizationPrefix}basal_rate`)
        }
      },
      [
        polyglot,
        basalRateState,
        pumpStatusRecency,
      ],
    )

    return (
      <div
        {...divProps}
        ref={propRef}
      >
        {basalRateStateString}
      </div>
    )
  },
)
